import { ExtendedError } from '../errors'

export class LoginInterruptedByUserError extends ExtendedError {
  name = LoginInterruptedByUserError.name
  code = 'INTERRUPTED'
  message = 'Login interrupted by user'
}

export class TooManyLoginAttemptsError extends ExtendedError {
  name = TooManyLoginAttemptsError.name
  code = 'MANY_ATTEMPTS'
  message = 'Too many login attempts'
}

export class InvalidPinError extends ExtendedError {
  name = InvalidPinError.name
  code = 'MANY_ATTEMPTS'
  message = 'Too many login attempts'
}

export class TooManyPinAttemptsError extends ExtendedError {
  name = TooManyPinAttemptsError.name
  code = 'MANY_PIN_ATTEMPTS'
  message = 'Too many PIN attempts'
}

export class NotEnoughPermissionsError extends ExtendedError {
  name = NotEnoughPermissionsError.name
  code = 'NOT_ENOUGH_PERMISSIONS'
  message = 'User has not enough permissions'
}

export class UserDisabledError extends ExtendedError {
  name = UserDisabledError.name
  code = 'USER_DISABLED'
  message = 'User disabled'
}

export class UserHasNoCredentialsError extends ExtendedError {
  name = UserHasNoCredentialsError.name
  code = 'NO_CREDENTIALS'
  message = 'User has no credentials'
}

export class WrongUserInformationError extends ExtendedError {
  name = WrongUserInformationError.name
  code = 'WRONG_INFORMATION'
  message = 'User information is not consistent'
}
